import { definePreset, palette } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import { CardDTO, TagDTO } from '../dtos/general.dto';
import { Frecuency, Pricing, Role, TypeCategory, TypeDisability, TypePost } from '../enums/types.enum';

export const AlteucostatPreset = definePreset(Lara, {
  semantic: {
    primary: palette('#F54257'),
  },
});

export const TYPE_POST_CONFIG = {
  [TypePost.Necessitat]: {
    color: 'bg-alteucostat-pink',
    icon: 'assets/icon/types-post/hand-solid.svg',
  },
  [TypePost.Oferta]: {
    color: 'bg-alteucostat-turquoise',
    icon: 'assets/icon/types-post/bullhorn-solid.svg',
  },
  [TypePost.Proposta]: {
    color: 'bg-alteucostat-green',
    icon: 'assets/icon/types-post/lightbulb-on-solid.svg',
  },
  [TypePost.Activitat]: {
    color: 'bg-alteucostat-blue',
    icon: 'assets/icon/types-post/notebook-solid.svg',
  },
  [TypePost.Noticia]: {
    color: 'bg-alteucostat-yellow',
    icon: 'assets/icon/types-post/newspaper-solid.svg',
  },
  [TypePost.Recurs]: {
    color: 'bg-alteucostat-beige',
    icon: 'assets/icon/types-post/notebook-solid.svg',
  },
};

export const CARDS_HOME: CardDTO[] = [
  {
    id: 'activities',
    title: 'ACTIVITIES.TITLE',
    icon: 'calendar-star',
    link: '/activities',
    roles: [Role.ORGANIZATION_ADMIN, Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'news',
    title: 'NEWS.TITLE',
    icon: 'newspaper',
    link: '/news',
    roles: [Role.ORGANIZATION_ADMIN, Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'profile',
    title: 'PROFILE.TITLE',
    icon: 'hands-holding-circle',
    link: '/my-organization',
    roles: [Role.ORGANIZATION_ADMIN],
  },
  {
    id: 'organizations',
    title: 'PROFILES.TITLE',
    icon: 'hands-holding-circle',
    link: '/organizations',
    roles: [Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'users',
    title: 'USERS.TITLE',
    icon: 'users',
    link: '/users',
    roles: [Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'user-blocks',
    title: 'USER_BLOCKS.TITLE',
    icon: 'ban',
    link: '/user-blocks',
    roles: [Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'chats',
    title: 'CHATS.TITLE',
    icon: 'comments',
    link: '/chats',
    roles: [Role.ORGANIZATION_ADMIN],
  },
  {
    id: 'community',
    title: 'COMMUNITY.TITLE',
    icon: 'heart',
    link: '/community',
    roles: [Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'statistics-entities',
    title: 'STATISTICS.ENTITIES',
    icon: 'assets/icon/statics-entities.svg',
    link: '/statistics/entitats',
    roles: [Role.ADMIN, Role.SUPER_ADMIN],
  },
  {
    id: 'statistics-users',
    title: 'STATISTICS.USERS',
    icon: 'assets/icon/statics-users.svg',
    link: '/statistics/usuaris',
    roles: [Role.ADMIN, Role.SUPER_ADMIN],
  }
];

export const SOCIAL_MEDIA_ITEMS = [
  {
    id: 'web',
    name: 'Web',
  },
  {
    id: 'youtube',
    name: 'Youtube',
  },
  {
    id: 'X',
    name: 'X',
  },
  {
    id: 'bluesky',
    name: 'BlueSky',
  },
  {
    id: 'facebook',
    name: 'Facebook',
  },
  {
    id: 'instagram',
    name: 'Instagram',
  },
  {
    id: 'tiktok',
    name: 'TikTok',
  }
];

export const ROLES: Role[] = [Role.CLIENT, Role.ADMIN];

export const ROLE_TAGS: TagDTO[] = [
  {
    id: Role.ADMIN,
    name: 'ROLES.ADMIN',
    selected: false,
  },
  {
    id: Role.SUPER_ADMIN,
    name: 'ROLES.SUPER_ADMIN',
    selected: false,
  },
  {
    id: Role.ORGANIZATION_ADMIN,
    name: 'ROLES.ORGANIZATION_ADMIN',
    selected: false,
  },
  {
    id: Role.CLIENT,
    name: 'ROLES.CLIENT',
    selected: false,
  },
  {
    id: Role.PUBLIC,
    name: 'ROLES.PUBLIC',
    selected: false,
  },
].sort((a, b) => a.id.localeCompare(b.id));

export const ROLE_TAGS_USER_VIEW: TagDTO[] = [
  {
    id: Role.SUPER_ADMIN,
    name: 'ROLES.SUPER_ADMIN',
    selected: false,
    view: [Role.SUPER_ADMIN]
  },
  {
    id: Role.ADMIN,
    name: 'ROLES.ADMIN',
    selected: false,
    view: [Role.SUPER_ADMIN, Role.ADMIN]
  },
  {
    id: Role.CLIENT,
    name: 'ROLES.CLIENT',
    selected: false,
    view: [Role.SUPER_ADMIN, Role.ADMIN]
  },
  {
    id: Role.PUBLIC,
    name: 'ROLES.PUBLIC',
    selected: false,
    view: [Role.SUPER_ADMIN, Role.ADMIN]
  },
  {
    id: Role.ORGANIZATION_ADMIN,
    name: 'ROLES.ORGANIZATION_ADMIN',
    selected: false,
    view: [Role.SUPER_ADMIN, Role.ADMIN]
  },
  {
    id: Role.ORGANIZATION,
    name: 'ROLES.ORGANIZATION',
    selected: false,
    view: [Role.SUPER_ADMIN]
  },
].sort((a, b) => a.id.localeCompare(b.id));

export enum TypeRelationship {
  User = 'user',
  Family = 'family',
  Work = 'work',
  Know = 'know',
  Other = 'other',
}

export const RELATIONSHIPS: any = [
  {
    id: TypeRelationship.User,
    name: 'USERS.RELATIONSHIPS.RELATION_USER_VALUE',
  },
  {
    id: TypeRelationship.Family,
    name: 'USERS.RELATIONSHIPS.RELATION_FAMILY_VALUE',
  },
  {
    id: TypeRelationship.Work,
    name: 'USERS.RELATIONSHIPS.RELATION_WORK_VALUE',
  },
  {
    id: TypeRelationship.Know,
    name: 'USERS.RELATIONSHIPS.RELATION_KNOW_VALUE',
  },
  {
    id: TypeRelationship.Other,
    name: 'USERS.RELATIONSHIPS.RELATION_OTHER_VALUE',
  }
].sort((a, b) => a.id.localeCompare(b.id));

export const DISABILITIES: TagDTO[] = [
  {
    id: TypeDisability.Physical,
    name: 'ENTITIES.TYPE_DISABILITY.PHYSICAL',
    selected: false,
  },
  {
    id: TypeDisability.Intellectual,
    name: 'ENTITIES.TYPE_DISABILITY.INTELLECTUAL',
    selected: false,
  },
  {
    id: TypeDisability.Autism,
    name: 'ENTITIES.TYPE_DISABILITY.AUTISM',
    selected: false,
  },
  {
    id: TypeDisability.Visual,
    name: 'ENTITIES.TYPE_DISABILITY.VISUAL',
    selected: false,
  },
  {
    id: TypeDisability.Hearing,
    name: 'ENTITIES.TYPE_DISABILITY.HEARING',
    selected: false,
  },
  {
    id: TypeDisability.Mental,
    name: 'ENTITIES.TYPE_DISABILITY.MENTAL',
    selected: false,
  },
  {
    id: TypeDisability.Other,
    name: 'ENTITIES.TYPE_DISABILITY.OTHER',
    selected: false,
  },
  {
    id: TypeDisability.Neurological,
    name: 'ENTITIES.TYPE_DISABILITY.NEUROLOGICAL',
    selected: false,
  },
  {
    id: TypeDisability.CerebralPalsy,
    name: 'ENTITIES.TYPE_DISABILITY.CEREBRAL_PALSY',
    selected: false,
  },
  {
    id: TypeDisability.Multidisability,
    name: 'ENTITIES.TYPE_DISABILITY.MULTIDISABILITY',
    selected: false,
  },
  {
    id: TypeDisability.Organic,
    name: 'ENTITIES.TYPE_DISABILITY.ORGANIC',
    selected: false,
  },
].sort((a, b) => a.id.localeCompare(b.id));

export const CATEGORIES: TagDTO[] = [
  {
    id: TypeCategory.Culture,
    name: 'TYPES_CATEGORY.CULTURE',
    src: 'assets/icon/categories-post/cultura.svg',
    selected: false,
    image: 'images/type-categories/cultura.webp',
  },
  {
    id: TypeCategory.HelpsLoans,
    name: 'TYPES_CATEGORY.HELPSLOANS',
    src: 'assets/icon/categories-post/ajuts-prestacions.svg',
    selected: false,
    image: 'images/type-categories/ajuts-prestacions.webp',
  },
  {
    id: TypeCategory.AdultsLeisure,
    name: 'TYPES_CATEGORY.ADULT_LEISURE',
    src: 'assets/icon/categories-post/lleure.svg',
    selected: false,
    image: 'images/type-categories/lleure-adult.webp',
  },
  {
    id: TypeCategory.ChildrenLeisure,
    name: 'TYPES_CATEGORY.CHILDREN_LEISURE',
    src: 'assets/icon/categories-post/lleure.svg',
    selected: false,
    image: 'images/type-categories/lleure-infantil.webp',
  },
  {
    id: TypeCategory.Healthcare,
    name: 'TYPES_CATEGORY.HEALTHCARE',
    src: 'assets/icon/categories-post/salut.svg',
    selected: false,
    image: 'images/type-categories/salut.webp',
  },
  {
    id: TypeCategory.Sports,
    name: 'TYPES_CATEGORY.SPORTS',
    src: 'assets/icon/categories-post/esports.svg',
    selected: false,
    image: 'images/type-categories/esports.webp',
  },
  {
    id: TypeCategory.Musical,
    name: 'TYPES_CATEGORY.MUSICAL',
    src: 'assets/icon/categories-post/musica.svg',
    selected: false,
    image: 'images/type-categories/musica.webp',
  },
  {
    id: TypeCategory.Artistic,
    name: 'TYPES_CATEGORY.ARTISTIC',
    src: 'assets/icon/categories-post/artistic.svg',
    selected: false,
    image: 'images/type-categories/artistic.webp',
  },
  {
    id: TypeCategory.Laboral,
    name: 'TYPES_CATEGORY.LABORAL',
    src: 'assets/icon/categories-post/laboral.svg',
    selected: false,
    image: 'images/type-categories/laboral.webp',
  },
  {
    id: TypeCategory.Training,
    name: 'TYPES_CATEGORY.TRAINING',
    src: 'assets/icon/categories-post/formacio.svg',
    selected: false,
    image: 'images/type-categories/formacio.webp',
  },
  {
    id: TypeCategory.Housing,
    name: 'TYPES_CATEGORY.HOUSING',
    src: 'assets/icon/categories-post/habitatge.svg',
    selected: false,
    image: 'images/type-categories/habitatge.webp',
  },
  {
    id: TypeCategory.Accessibility,
    name: 'TYPES_CATEGORY.ACCESSIBILITY',
    src: 'assets/icon/categories-post/accessibilitat.svg',
    selected: false,
    image: 'images/type-categories/accessibilitat.webp',
  },
  {
    id: TypeCategory.School,
    name: 'TYPES_CATEGORY.SCHOOL',
    src: 'assets/icon/categories-post/escolar.svg',
    selected: false,
    image: 'images/type-categories/escolar.webp',
  },
  {
    id: TypeCategory.Information,
    name: 'TYPES_CATEGORY.INFORMATION',
    src: 'assets/icon/categories-post/informacio.svg',
    selected: false,
    image: 'images/type-categories/informacio.webp',
  },
  {
    id: TypeCategory.Sensitization,
    name: 'TYPES_CATEGORY.SENSITIZATION',
    src: 'assets/icon/categories-post/sensibilitzacio.svg',
    selected: false,
    image: 'images/type-categories/sensibilitzacio.webp',
  }
].sort((a, b) => a.id.localeCompare(b.id));

export const FRECUENCY = [
  {
    id: Frecuency.None,
    name: 'NEW_ACTIVITY_FORM_FIELDS.ACTIVITAT_PUNTUAL',
  },
  {
    id: Frecuency.Weekly,
    name: 'NEW_ACTIVITY_FORM_FIELDS.ACTIVITAT_SETMANAL',
  },
  {
    id: Frecuency.Weekly_2,
    name: 'NEW_ACTIVITY_FORM_FIELDS.ACTIVITAT_QUINZENAL',
  },
];

export const PRICING = [
  {
    id: Pricing.FREE,
    name: 'PRICING.FREE',
  },
  {
    id: Pricing.PAID,
    name: 'PRICING.PAID',
  },
];

export const USER_STATES = [
  {
    value: true,
    name: 'USER_DETAILS_VIEW.STATES.ACTIVE',
  },
  {
    value: false,
    name: 'USER_DETAILS_VIEW.STATES.INACTIVE',
  },
];
